import { FIELD_TYPES } from "constants/template-field-type";
import ThemeConfig from "segments/core-configs/theme-config";
import DefaultProps from "./default-props";
import { BADGES_COUNTRIES } from "./badges-const";

export default {
  type: FIELD_TYPES.NESTED,
  label: "Badges",
  fields: {
    ...ThemeConfig,
    product: {
      type: FIELD_TYPES.PRODUCTS,
      label: "Product"
    },
    country: {
        type: FIELD_TYPES.COMBO,
        label: "Country",
        options: BADGES_COUNTRIES
    },
    horizontalPadding: {
      type: FIELD_TYPES.TEXT,
      label: "Horizontal padding",
      inputPlaceholder: DefaultProps.horizontalPadding
    }
  }
};
